import React, { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';

interface PageSkeletonProps {
}

const PageSkeleton: FC<PageSkeletonProps> = () => (
    <div data-testid="PageSkeleton">
        <Stack
            spacing={4}
            sx={{ px: 3, py: 8 }}
        >
            <Stack direction="row" spacing={2}>
                <Skeleton variant="circular" width={32} height={32} />
                <Skeleton variant="rounded" width={200} height={32} />
            </Stack>
            <Skeleton variant="rounded" height={240} />
            <Skeleton variant="rounded" height={120} />
        </Stack>
    </div>
);

export default PageSkeleton;
